import { render, staticRenderFns } from "./iconoChat.vue?vue&type=template&id=6f12a3f4&scoped=true"
import script from "./iconoChat.vue?vue&type=script&lang=js"
export * from "./iconoChat.vue?vue&type=script&lang=js"
import style0 from "./iconoChat.vue?vue&type=style&index=0&id=6f12a3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12a3f4",
  null
  
)

export default component.exports